import "@xola/ui-kit/build/style.css";
import "@xola/ui-kit/index.css";
import React from "react";
import ReactDOM from "react-dom";
import "simplebar/dist/simplebar.min.css";
// eslint-disable-next-line import/no-unassigned-import
import "@fullcalendar/react/dist/vdom";
import pluralize from "pluralize";
import { bootstrapAuth } from "./auth/oauthSessionHelper";
import { App } from "./components/App";
import "./styles/print.css";

// Configure pluralize for app-wide uncountable words
pluralize.addUncountableRule("Merchandise");

// Not awaited: `Router` renders a skeleton until the auth store settles. It never rejects.
void bootstrapAuth();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.querySelector("#root"),
);
